import { Component, OnInit } from '@angular/core';
import { ICellComponent } from 'src/app/modules/records/models/i-cell-component';
import { RatingColOnlineRep } from 'src/app/shared/table-col-configs/rating-onlinerep-col';

@Component({
  selector: 'app-check-response-online',
  templateUrl: './check-response-online.component.html',
  styleUrls: ['./check-response-online.component.scss']
})
export class CheckResponseOnlineComponent<T extends object>
  implements OnInit, ICellComponent<T> {

  dataCheck!: any
  checkResponse: boolean = false;
  data: any;
  checkTrue = "../../../../../assets/svg/checks/checkTrue.svg"
  checkFalse = "../../../../../assets/svg/checks/checkFalse.svg"

  constructor() { }

  ngOnInit(): void {
  }

  setComponentData(el: T, colConfig: RatingColOnlineRep<T>) {
    this.data = colConfig.getElementData(el);
    this.dataCheck = el;
    if (this.dataCheck.responseFlag.includes('true')) {
      this.checkResponse = true;
    } else {
      this.checkResponse = false;
    }
  }

}
